export default "__VITE_ASSET__7xlvhCUk__"